export default {
    "num01": require('@a/lotteryNum/num01.png'),
    "num02": require('@a/lotteryNum/num02.png'),
    "num03": require('@a/lotteryNum/num03.png'),
    "num04": require('@a/lotteryNum/num04.png'),
    "num05": require('@a/lotteryNum/num05.png'),
    "num06": require('@a/lotteryNum/num06.png'),
    "num07": require('@a/lotteryNum/num07.png'),
    "num08": require('@a/lotteryNum/num08.png'),
    "num09": require('@a/lotteryNum/num09.png'),
    "num10": require('@a/lotteryNum/num10.png'),
    "touzi1": require('@a/lotteryNum/touzi1.png'),
    "touzi2": require('@a/lotteryNum/touzi2.png'),
    "touzi3": require('@a/lotteryNum/touzi3.png'),
    "touzi4": require('@a/lotteryNum/touzi4.png'),
    "touzi5": require('@a/lotteryNum/touzi5.png'),
    "touzi6": require('@a/lotteryNum/touzi6.png'),
}